<template>
  <v-main>
    <v-container fluid>
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

      <v-card>
        <v-card-title>
          Jadwal Konsultasi
          <v-spacer></v-spacer>

          <v-btn color="purple" dark class="mb-2" @click="doAdd">
            Tambah
          </v-btn>

          <v-dialog v-model="dialog" persistent max-width="600">
            <v-card>
              <v-card-title>
                <span class="text-h5">Jadwal Praktek Dokter</span>
              </v-card-title>
              <v-card-text>
                <v-form
                  ref="form"
                  v-model="valid"
                  lazy-validation
                  class="pl-4 pr-4 pt-4"
                >
                  <v-row>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedHari"
                        label="Hari"
                        clearable
                        dense
                        outlined
                        :items="items_hari"
                        item-text="value"
                        item-value="code"
                        :rules="currentData.hariRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        v-model="currentData.selectedDokter"
                        label="Dokter"
                        clearable
                        dense
                        outlined
                        :items="items_dokter"
                        item-text="nama"
                        item-value="id"
                        :rules="currentData.dokterRules"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-text-field
                            v-model="currentData.jam_awal"
                            label="Jam"
                            type="time"
                            dense
                            outlined
                            :rules="currentData.jamAwalRules"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">
                  Close
                </v-btn>
                <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialogDelete" max-width="500px">
            <v-card>
              <v-card-title class="text-h5"
                >Apa anda akan menghapus data ini?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Tidak</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >Ya</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-card-title>

        <v-row class="mx-4 my-4">
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedHari"
              label="Hari"
              clearable
              dense
              outlined
              :items="items_hari"
              item-text="value"
              item-value="code"
              @change="changeHari"
            ></v-combobox>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <v-combobox
              v-model="selectedDokter"
              label="Dokter"
              clearable
              dense
              outlined
              :items="items_dokter"
              item-text="nama"
              item-value="id"
              @change="changeDokter"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-data-table
          :headers="headers"
          :items="list_data"
          :options.sync="options"
          :server-items-length="totalData"
          :loading="loading"
          class="elevation-1"
        >
          <template #[`item.jam_awal`]="{ item }">
            <div>{{ item.jam_awal }}</div>
          </template>

          <template #[`item.actions`]="{ item }">
            <v-icon medium class="mr-3" @click="editItem(item)">
              mdi-pencil
            </v-icon>
            <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template #[`item.foto_url`]="{ item }">
            <v-responsive v-if="item.foto_url_original">
              <v-img :src="item.foto_url" contain width="100"></v-img>
            </v-responsive>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import JadwalKonsultasiService from "../services/JadwalKonsultasiService";
import CommonService from "../services/CommonService";
import MasterService from "../services/MasterService";
import NakesService from "../services/NakesService";

export default {
  data: () => ({
    valid: true,
    breadcrumbs: [
      {
        text: "Data Jadwal Konsultasi",
        disabled: true,
        href: "breadcrumbs_dashboard",
      },
    ],
    selectedHari: "",
    selectedDokter: "",
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Hari", value: "nama_hari", sortable: false },
      { text: "Dokter", value: "nama_dokter", sortable: false },
      { text: "Jam", value: "jam_awal", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 10,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentData: {
      id: null,
      selectedHari: null,
      selectedDokter: null,
      jam_awal: null,
      hariRules: [(v) => !!v || "Hari harus diisi"],
      dokterRules: [(v) => !!v || "Dokter harus diisi"],
      jamAwalRules: [(v) => !!v || "Jam Awal harus diisi"],
    },

    items_hari: [],
    items_dokter: [],
  }),
  watch: {
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getDataFromApi();
    this.getListHari();
    this.getListNakes();
  },
  methods: {
    getDataFromApi() {
      const { page, itemsPerPage } = this.options;

      let hari = "";
      let dokter = "";

      if (this.selectedHari) {
        hari = this.selectedHari.code;
      }

      if (this.selectedDokter) {
        dokter = this.selectedDokter.id;
      }

      this.loading = true;
      JadwalKonsultasiService.jadwalList(page, itemsPerPage, hari, dokter)
        .then((res) => {
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    changeHari: async function () {
      this.getDataFromApi();
    },

    changeDokter: async function () {
      this.getDataFromApi();
    },

    async getListHari() {
      MasterService.hariList()
        .then((res) => {
          this.items_hari = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async getListNakes() {
      NakesService.nakesListAll()
        .then((res) => {
          this.items_dokter = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    doAdd: async function () {
      this.dialog = true;
      this.currentData.id = null;
      this.currentData.selectedHari = "";
      this.currentData.selectedDokter = "";
      this.currentData.jam_awal = "";
    },

    doSave: async function () {
      if (!this.$refs.form.validate()) {
        window.scrollTo(0, 0);
        return;
      }

      if (this.currentData.id != null) {
        JadwalKonsultasiService.update(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Update jadwal berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Update jadwal gagal. Coba lagi");
          });
      } else {
        JadwalKonsultasiService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;
            CommonService.showSuccessToast("Tambah jadwal berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);
            CommonService.showErrorToast("Tambah jadwal gagal. Coba lagi");
          });
      }
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      this.currentData.id = this.editedItem.id;
      this.currentData.selectedHari = null;
      this.currentData.selectedDokter = null;
      this.currentData.jam_awal = this.editedItem.jam_awal;

      if (this.editedItem.hari) {
        this.items_hari.forEach((entry) => {
          if (this.editedItem.hari == entry.code) {
            this.currentData.selectedHari = entry;
          }
        });
      }

      if (this.editedItem.user_id) {
        this.items_dokter.forEach((entry) => {
          if (this.editedItem.user_id == entry.id) {
            this.currentData.selectedDokter = entry;
          }
        });
      }
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      JadwalKonsultasiService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus jadwal berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);

          CommonService.showErrorToast("Hapus jadwal gagal. Coba lagi");
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
  },
};
</script>
